import React from "react";
import { Route } from "react-router-dom";
import { CustomersLoadingDialog } from "./customers-loading-dialog/CustomersLoadingDialog";
import { CustomerEditDialog } from "./customer-edit-dialog/CustomerEditDialog";
import { CustomerDeleteDialog } from "./customer-delete-dialog/CustomerDeleteDialog";
import { CustomersDeleteDialog } from "./customers-delete-dialog/CustomersDeleteDialog";
import { CustomersFetchDialog } from "./customers-fetch-dialog/CustomersFetchDialog";
import { CustomersUpdateStateDialog } from "./customers-update-status-dialog/CustomersUpdateStateDialog";
import { CustomersUIProvider } from "./CustomersUIContext";
import { CustomersCard } from "./CustomersCard";

export function CustomersPage({ history }) {
  const customersUIEvents = {
    newCustomerButtonClick: () => {
      history.push("/clientes/new");
    },
    openEditCustomerDialog: (id) => {
      history.push(`/clientes/${id}/edit`);
    },
    openDeleteCustomerDialog: (id) => {
      history.push(`/clientes/${id}/delete`);
    },
    openDeleteCustomersDialog: () => {
      history.push(`/clientes/deleteCustomers`);
    },
    openFetchCustomersDialog: () => {
      history.push(`/clientes/fetch`);
    },
    openUpdateCustomersStatusDialog: () => {
      history.push("/clientes/updateStatus");
    }
  }

  return (
    <CustomersUIProvider customersUIEvents={customersUIEvents}>
      <CustomersLoadingDialog />

      <Route path="/clientes/new">
        {({ history, match }) => (
          <CustomerEditDialog
            show={match != null}
            onHide={() => {
              history.push("/clientes");
            }}
          />
        )}
      </Route>
      <Route path="/clientes/:id/edit">
        {({ history, match }) => (
          <CustomerEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/clientes");
            }}
          />
        )}
      </Route>
      <Route path="/clientes/deleteCustomers">
        {({ history, match }) => (
          <CustomersDeleteDialog
            show={match != null}
            onHide={() => {
              history.push("/clientes");
            }}
          />
        )}
      </Route>
      <Route path="/clientes/:id/delete">
        {({ history, match }) => (
          <CustomerDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/clientes");
            }}
          />
        )}
      </Route>
      <Route path="/clientes/fetch">
        {({ history, match }) => (
          <CustomersFetchDialog
            show={match != null}
            onHide={() => {
              history.push("/clientes");
            }}
          />
        )}
      </Route>
      <Route path="/clientes/updateStatus">
        {({ history, match }) => (
          <CustomersUpdateStateDialog
            show={match != null}
            onHide={() => {
              history.push("/clientes");
            }}
          />
        )}
      </Route>
      <CustomersCard />
    </CustomersUIProvider>
  );
}
